// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledUiCard = styled('div')(
  () => css`
    &.ui-card,
    .ui-card {
      border-radius: 8px;
      box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1), 0 0 0 1px #fcfcfc;

      .ui-card-header {
        border-radius: 8px;
        height: 48px;
        background: #ffffff;
        border: 1px solid #f5f5f5;
        position: relative;
      }

      .ui-card-body,
      .ui-card-footer {
        background: #ffffff;
      }
    }
  `
);
